










































































































import {Component, Vue} from 'vue-property-decorator'

@Component
export default class OrbitRefundConfirmStep extends Vue {
  onConfirm() {
    this.$emit('confirm')
  }

  onCancel() {
    this.$emit('cancel')
  }
}
